import * as React from 'react'
import { Switch as SwitchPrimitive } from 'radix-ui'

import { cn } from '../utils/cn'

type SwitchSize = 'sm' | 'md' | 'lg'

function Switch({
  className,
  size = 'md',
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root> & {
  size?: SwitchSize
}) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      data-size={size}
      className={cn(
        'peer group/switch relative inline-flex shrink-0 items-center rounded-full border border-transparent transition-colors outline-none',
        'focus-visible:ring-2 focus-visible:ring-gold/40 focus-visible:ring-offset-2 focus-visible:ring-offset-midnight',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'data-[state=checked]:bg-gold data-[state=unchecked]:bg-charcoal',
        'data-[size=sm]:h-5 data-[size=sm]:w-9',
        'data-[size=md]:h-6 data-[size=md]:w-11',
        'data-[size=lg]:h-8 data-[size=lg]:w-14',
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          'pointer-events-none block rounded-full bg-white shadow ring-0 transition-transform',
          'group-data-[size=sm]/switch:size-4 group-data-[size=sm]/switch:translate-x-0.5 group-data-[size=sm]/switch:data-[state=checked]:translate-x-4',
          'group-data-[size=md]/switch:size-5 group-data-[size=md]/switch:translate-x-0.5 group-data-[size=md]/switch:data-[state=checked]:translate-x-[1.375rem]',
          'group-data-[size=lg]/switch:size-7 group-data-[size=lg]/switch:translate-x-0.5 group-data-[size=lg]/switch:data-[state=checked]:translate-x-6',
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
export type { SwitchSize }
